import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { createContext, memo } from "react";

export interface UnifiedBillingSuiteStatuses {
  unifiedBillingEnabled: boolean;
}

export const UnifiedBillingSuiteStatusesContext = createContext<
  UnifiedBillingSuiteStatuses | undefined
>(undefined);

export const UnifiedBillingSuiteStatusesProvider = memo(
  function UnifiedBillingSuiteStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
    const hasBillingPermission = useHasPermission(
      SettingsPermissions.VIEW_BILLING,
    );

    const billingSettingsLoad = useLoad(async () => {
      if (!hasBillingPermission) {
        return { unifiedBillingEnabled: false };
      }
      return rpcClient.getAccountBillingSettings({});
    }, [rpcClient, hasBillingPermission]);

    const unifiedBillingSuiteStatuses: UnifiedBillingSuiteStatuses = {
      unifiedBillingEnabled:
        billingSettingsLoad.value?.unifiedBillingEnabled ?? false,
    };

    return (
      <UnifiedBillingSuiteStatusesContext.Provider
        value={unifiedBillingSuiteStatuses}
      >
        {children}
      </UnifiedBillingSuiteStatusesContext.Provider>
    );
  },
);
